import React, { useState } from "react";
import axios from "../api";
import { useHistory } from "react-router-dom";
import {
  computeSumasDeTurnos,
  pasarSumasTurnosACierreDiaApi,
} from "../services/pasarSumasCierreDia";
import "../cierreTurno/CierreTurno.css";

const formatDate = (d) => {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d) : d;
  return isNaN(date.getTime()) ? String(d) : date.toLocaleString();
};

const TrasmitirGlobalContainer = () => {
  const history = useHistory();
  const [cierreTurnoData, setCierreTurnoData] = useState([]);
  const [cierreDiaData, setCierreDiaData] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [trasmitiendoCierreDia, setTrasmitiendoCierreDia] = useState(false);
  const [filtros, setFiltros] = useState({
    centroCostos: "",
    codTerminal: "",
    fechaInicial: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleBuscar = async (e) => {
    e.preventDefault();
    const { centroCostos, codTerminal, fechaInicial } = filtros;
    if (!centroCostos || !codTerminal || !fechaInicial) {
      alert("Por favor complete todos los campos: Centro de costos, Código terminal y Fecha.");
      return;
    }
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicial)) {
      alert("El formato de fecha debe ser YYYY-MM-DD");
      return;
    }
    const payload = {
      codTerminal,
      codPark: centroCostos,
      fechaInicial,
    };
    setCargando(true);
    try {
      const [resTurno, resDia] = await Promise.all([
        axios.post("/cierre-turno/filtrar", payload),
        axios.post("/cierres-dias/buscar", payload),
      ]);
      setCierreTurnoData(Array.isArray(resTurno.data) ? resTurno.data : []);
      setCierreDiaData(Array.isArray(resDia.data) ? resDia.data : []);
    } catch (error) {
      console.error("Error al buscar:", error);
      alert(
        error.response?.data?.message ||
          error.message ||
          "Error al consultar cierres."
      );
      setCierreTurnoData([]);
      setCierreDiaData([]);
    } finally {
      setCargando(false);
    }
  };

  const handleLimpiar = () => {
    setFiltros({ centroCostos: "", codTerminal: "", fechaInicial: "" });
    setCierreTurnoData([]);
    setCierreDiaData([]);
  };

  const sumasDeTurnos = React.useMemo(
    () => computeSumasDeTurnos(cierreTurnoData),
    [cierreTurnoData]
  );

  const [aplicando, setAplicando] = useState(false);

  const habilitarTrasmisionCierreDia =
    !cargando &&
    cierreDiaData.length === 0 &&
    !!filtros.centroCostos &&
    !!filtros.codTerminal &&
    !!filtros.fechaInicial;

  const handleTrasmisionCierreDia = async () => {
    if (!habilitarTrasmisionCierreDia) return;

    setTrasmitiendoCierreDia(true);
    try {
      const payload = {
        codTerminal: filtros.codTerminal,
        codPark: filtros.centroCostos,
        fechaInicial: filtros.fechaInicial,
      };

      await axios.post(
        "/cierre-turno/trasmision-cierre-dia",
        payload
      );

      // Refrescar datos luego de activar el turno estado 3 -> estado 1
      const [resTurno, resDia] = await Promise.all([
        axios.post("/cierre-turno/filtrar", payload),
        axios.post("/cierres-dias/buscar", payload),
      ]);

      setCierreTurnoData(Array.isArray(resTurno.data) ? resTurno.data : []);
      setCierreDiaData(Array.isArray(resDia.data) ? resDia.data : []);

      alert("Trasmicion cierre dia ejecutada correctamente.");
    } catch (error) {
      console.error("Error al trasmision cierre dia:", error);
      const msg =
        error.response?.data?.message ||
        (typeof error.response?.data === "string" ? error.response?.data : null) ||
        error.message ||
        "Error al ejecutar la trasmision de cierre dia.";
      alert(msg);
    } finally {
      setTrasmitiendoCierreDia(false);
    }
  };

  const handlePasarSumasACierreDia = async () => {
    if (!sumasDeTurnos || !cierreDiaData.length) return;
    setAplicando(true);
    try {
      const data = await pasarSumasTurnosACierreDiaApi({
        cierreTurnoData,
        cierreDiaData,
        codTerminal: filtros.codTerminal,
        codPark: filtros.centroCostos,
        fechaInicial: filtros.fechaInicial,
        validarDiaAnterior: true,
      });
      const aviso = data?._avisoIdInicioDia;
      const turnosActualizados = data?._cierreTurnoData;
      setCierreDiaData(Array.isArray(data) ? data : []);
      if (Array.isArray(turnosActualizados)) {
        setCierreTurnoData(turnosActualizados);
      }
      if (aviso) {
        alert(
          `Sumas de turnos aplicadas al cierre de día correctamente.\n\n${aviso}`
        );
      } else {
        alert("Sumas de turnos aplicadas al cierre de día correctamente.");
      }
    } catch (error) {
      console.error("Error al aplicar sumas:", error);
      alert(
        error.response?.data?.message ||
          error.message ||
          "Error al actualizar cierre de día."
      );
    } finally {
      setAplicando(false);
    }
  };

  const handleVolverHome = () => history.push('/Planillas');

  return (
    <div className="cierre-turno-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 className="cierre-turno-title">Trasmitir a Global</h2>
        <button
          onClick={handleVolverHome}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          ← Volver al Home
        </button>
      </div>

      <form
        onSubmit={handleBuscar}
        className="cierre-turno-form"
        style={{ marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group">
            <label>Centro de costos:</label>
            <input
              type="text"
              name="centroCostos"
              value={filtros.centroCostos}
              onChange={handleChange}
              placeholder="Ej: 491"
            />
          </div>
          <div className="form-group">
            <label>Código terminal:</label>
            <input
              type="text"
              name="codTerminal"
              value={filtros.codTerminal}
              onChange={handleChange}
              placeholder="Ej: P491"
            />
          </div>
          <div className="form-group">
            <label>Fecha:</label>
            <input
              type="date"
              name="fechaInicial"
              value={filtros.fechaInicial}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="form-buttons">
          <button type="submit" className="buscar-btn" disabled={cargando}>
            {cargando ? "Buscando..." : "Buscar"}
          </button>
          <button type="button" className="cancelar-btn" onClick={handleLimpiar}>
            Limpiar
          </button>
        </div>
      </form>

      {cierreTurnoData.length > 0 && (
        <div className="table-container" style={{ overflowX: "auto" }}>
          <h3>Cierre de turno</h3>
          <table className="cierre-turno-table" style={{ minWidth: "1400px" }}>
            <thead>
              <tr>
                <th>cod_terminal</th>
                <th>cod_park</th>
                <th>cod_empleado</th>
                <th>fecha_final</th>
                <th>factura_ini</th>
                <th>factura_fin</th>
                <th>total</th>
                <th>subtotal</th>
                <th>reportado</th>
                <th>total_efectivo</th>
                <th>total_tc</th>
                <th>total_mensuales_ef</th>
                <th>total_mensuales_tc</th>
                <th>iva_efectivo</th>
                <th>iva_datafono</th>
                <th>notas_credito</th>
                <th>estado</th>
                <th>id_inicio_turno</th>
                <th>id_inicio_dia</th>
              </tr>
            </thead>
            <tbody>
              {cierreTurnoData.map((row) => (
                <tr key={row.id}>
                  <td>{row.codTerminal}</td>
                  <td>{row.codPark}</td>
                  <td>{row.codEmpleado}</td>
                  <td>{formatDate(row.fechaFinal)}</td>
                  <td>{row.facturaIni}</td>
                  <td>{row.facturaFin}</td>
                  <td>{row.total}</td>
                  <td>{row.subtotal}</td>
                  <td>{row.reportado}</td>
                  <td>{row.totalEfectivo}</td>
                  <td>{row.totalTc}</td>
                  <td>{row.totalMensualesEf}</td>
                  <td>{row.totalMensualesTc}</td>
                  <td>{row.ivaEfectivo}</td>
                  <td>{row.ivaDatafono}</td>
                  <td>{row.notasCredito}</td>
                  <td>{row.estado}</td>
                  <td>{row.idInicioTurno}</td>
                  <td>{row.idInicioDia}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {sumasDeTurnos && cierreDiaData.length > 0 && (
            <div style={{ marginTop: "12px" }}>
              <button
                type="button"
                className="buscar-btn"
                disabled={aplicando}
                onClick={handlePasarSumasACierreDia}
              >
                {aplicando ? "Aplicando..." : "Pasar sumas de turnos a cierre de día"}
              </button>
            </div>
          )}
        </div>
      )}

      {cierreDiaData.length > 0 && (
        <div className="table-container" style={{ marginTop: "16px", overflowX: "auto" }}>
          <h3>Cierre de día</h3>
          <table className="cierre-turno-table" style={{ minWidth: "1400px" }}>
            <thead>
              <tr>
                <th>cod_terminal</th>
                <th>cod_park</th>
                <th>fecha_final</th>
                <th>id_inicio_dia</th>
                <th>factura_ini</th>
                <th>factura_fin</th>
                <th>turnos</th>
                <th>total</th>
                <th>subtotal</th>
                <th>total_efectivo_dia</th>
                <th>total_efectivo</th>
                <th>total_tc</th>
                <th>total_mensuales_ef</th>
                <th>total_mensuales_tc</th>
                <th>iva_efectivo</th>
                <th>iva_datafono</th>
                <th>total_notas_credito</th>
                <th>estado</th>
                <th>id_planilla</th>
              </tr>
            </thead>
            <tbody>
              {cierreDiaData.map((row) => (
                <tr key={row.idCierreDia}>
                  <td>{row.codTerminal}</td>
                  <td>{row.codPark}</td>
                  <td>{formatDate(row.fechaFinal)}</td>
                  <td>{row.idInicioDia}</td>
                  <td>{row.facturaIni}</td>
                  <td>{row.facturaFin}</td>
                  <td>{row.turnos}</td>
                  <td>{row.total}</td>
                  <td>{row.subtotal}</td>
                  <td>{row.totalEfectivoDia}</td>
                  <td>{row.totalEfectivo}</td>
                  <td>{row.totalTc}</td>
                  <td>{row.totalMensualesEf}</td>
                  <td>{row.totalMensualesTc}</td>
                  <td>{row.ivaEfectivo}</td>
                  <td>{row.ivaDatafono}</td>
                  <td>{row.totalNotasCredito}</td>
                  <td>{row.estado}</td>
                  <td>{row.idPlanilla}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!cargando &&
        cierreDiaData.length === 0 &&
        filtros.centroCostos &&
        filtros.codTerminal &&
        filtros.fechaInicial && (
          <div style={{ marginTop: "20px" }}>
            <p style={{ color: "#666", margin: 0 }}>
              No se encontraron cierres de día para los filtros indicados.
            </p>
            {habilitarTrasmisionCierreDia && (
              <div style={{ marginTop: "12px" }}>
                <button
                  type="button"
                  className="buscar-btn"
                  disabled={trasmitiendoCierreDia}
                  onClick={handleTrasmisionCierreDia}
                >
                  {trasmitiendoCierreDia
                    ? "Ejecutando..."
                    : "Trasmicion cierre dia"}
                </button>
              </div>
            )}
          </div>
        )}
    </div>
  );
};

export default TrasmitirGlobalContainer;
